import * as React from 'react'
import { useTheme } from 'styled-components'

interface Props {
  max: number
  value: number
  style?: React.CSSProperties
  color?: string
  thresholds?: number[]
}

export default function ProgressBarComponent ({ max, value, style, color, thresholds }: Props) {
  const theme = useTheme()
  const thresholdsStyle: React.CSSProperties = thresholds ? { position: 'relative', overflow: 'visible' } : {}

  return <div className="progressBar" style={{ ...thresholdsStyle, ...style }}>
    <div className="progressBar-inner" style={{ width: `${100 * value / max}%`, backgroundColor: color || theme.colors.clr_1 }}></div>
    
    { thresholds?.map((threshold, index) => <div
      key={ index }
      style={{
        position: 'absolute',
        left: `${(threshold / max) * 100}%`,
        top: '-5px',
        bottom: '-5px',
        width: '1px',
        backgroundColor: theme.colors.clr_0_light,
        zIndex: 1
      }} />) }
  </div>
}
